var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reporte"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1130 -354L-1106 -354L-1106 -330L-1130 -330L-1130 -354Z",
    id: "Reporte",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reporte",
    component: "53bd2f21-7df0-4e6a-8977-1b605ea458e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99929 15.6221L13.5588 15.6221C14.4711 14.1328 15.9639 13.0497 17.712 12.7045L17.712 3.31677C17.712 2.11578 16.7349 1.13867 15.5339 1.13867L13.9742 1.13867L13.9742 1.95664C13.9742 3.04002 13.0928 3.92145 12.0094 3.92145L5.93012 3.92145C4.84674 3.92145 3.9653 3.04002 3.9653 1.95664L3.9653 1.13867L2.40563 1.13867C1.20465 1.13867 0.227539 2.11578 0.227539 3.31677L0.227539 21.7161C0.227539 22.9171 1.20465 23.8942 2.40563 23.8942L14.8021 23.8942C13.4575 22.7137 12.6046 20.9662 12.6046 19.0195C12.6046 18.3417 12.7083 17.6882 12.8998 17.0742L3.99929 17.0742C3.59832 17.0742 3.27324 16.7491 3.27324 16.3482C3.27324 15.9472 3.59832 15.6221 3.99929 15.6221L3.99929 15.6221ZM3.99924 7.04297L13.9412 7.04297C14.3422 7.04297 14.6673 7.36805 14.6673 7.76902C14.6673 8.16998 14.3422 8.49506 13.9412 8.49506L3.99924 8.49506C3.59827 8.49506 3.27319 8.16998 3.27319 7.76902C3.27319 7.36805 3.59827 7.04297 3.99924 7.04297L3.99924 7.04297ZM3.99924 9.90259L13.9412 9.90259C14.3422 9.90259 14.6673 10.2277 14.6673 10.6286C14.6673 11.0296 14.3422 11.3547 13.9412 11.3547L3.99924 11.3547C3.59827 11.3547 3.27319 11.0296 3.27319 10.6286C3.27319 10.2277 3.59827 9.90259 3.99924 9.90259L3.99924 9.90259ZM3.99924 12.7625L13.9412 12.7625C14.3422 12.7625 14.6673 13.0875 14.6673 13.4885C14.6673 13.8895 14.3422 14.2145 13.9412 14.2145L3.99924 14.2145C3.59827 14.2145 3.27319 13.8895 3.27319 13.4885C3.27319 13.0875 3.59827 12.7625 3.99924 12.7625L3.99924 12.7625Z",
    id: "Shape",
    fill: "#59ADFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 0L5.93025 0C5.6475 0 5.41748 0.230016 5.41748 0.512766L5.41748 1.95661C5.41748 2.23936 5.6475 2.46937 5.93025 2.46937L12.0095 2.46937C12.2923 2.46937 12.5223 2.23936 12.5223 1.95661L12.5223 0.512766C12.5223 0.230016 12.2922 0 12.0095 0L12.0095 0Z",
    id: "Shape",
    fill: "#59ADFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9144 14.0388C16.2358 14.0388 14.0566 16.2731 14.0566 19.0194C14.0566 21.7657 16.2358 24 18.9144 24C21.593 24 23.7721 21.7657 23.7721 19.0194C23.7721 16.2731 21.593 14.0388 18.9144 14.0388L18.9144 14.0388ZM20.9475 21.7414C20.8171 21.8387 20.6647 21.8857 20.5136 21.8857C20.2924 21.8857 20.0739 21.785 19.9313 21.5941L18.3328 19.4539C18.2391 19.3284 18.1885 19.176 18.1885 19.0195L18.1885 17.4692C18.1885 17.0682 18.5136 16.7432 18.9145 16.7432C19.3155 16.7432 19.6405 17.0682 19.6405 17.4692L19.6405 18.7782L21.0947 20.7251C21.3346 21.0464 21.2687 21.5014 20.9475 21.7414L20.9475 21.7414Z",
    id: "Shape",
    fill: "#0B9ACE",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape15);
export default __webpack_public_path__ + "static/media/shape15.5b55e6c8499368e5a23de5d6c2adfdac.svg";
export { ForwardRef as ReactComponent };